import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import api from '../lib/api';
import { useAuth } from '../contexts/AuthContext';

export default function MagicRedeem() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { setAuthFromToken } = useAuth();
  const [state, setState] = useState('redeeming'); // redeeming | ok | error
  const [error, setError] = useState('');

  useEffect(() => {
    const token = params.get('token');
    const redirect = params.get('redirect') || '/mi-camino';
    if (!token) { setState('error'); setError('Falta el token'); return; }

    api.post('/auth/magic/redeem', { token })
      .then(({ data }) => {
        // Feed the auth context with the JWT so navigation is authenticated.
        if (typeof setAuthFromToken === 'function') {
          setAuthFromToken(data.token, data.user);
        } else {
          localStorage.setItem('token', data.token);
          localStorage.setItem('user', JSON.stringify(data.user));
        }
        setState('ok');
        setTimeout(() => navigate(redirect, { replace: true }), 400);
      })
      .catch((e) => {
        setState('error');
        setError(e.response?.data?.detail || 'Enlace inválido');
      });
  }, []);

  return (
    <div className="min-h-screen bg-[#FDFCFA] flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center">
        {state === 'redeeming' && (
          <>
            <Loader2 className="w-8 h-8 animate-spin text-[#c9a227] mx-auto mb-4" />
            <p className="text-sm text-[#5a5d53]">Preparando tu acceso…</p>
          </>
        )}
        {state === 'ok' && (
          <p className="text-sm text-[#8a7428]">Todo listo, te llevamos a tu camino.</p>
        )}
        {state === 'error' && (
          <>
            <h1 className="font-heading text-2xl text-[#2a2d24] mb-3">Enlace no válido</h1>
            <p className="text-sm text-[#5a5d53] mb-4">{error}</p>
            <a href="/login" className="text-sm text-[#8a7428] hover:underline">Ir a iniciar sesión</a>
          </>
        )}
      </div>
    </div>
  );
}
